// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UPRN Dataset Popup - Theme-Aware Design
 * Uses cfn-theme.css CSS custom properties for consistent theming
 */

/* Content styling only - outer wrapper (border-radius, shadow, width)
   is handled by the tabbed popup system */
.uprn-dataset-popup {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--cfn-text-primary);
  background: var(--cfn-popup-bg);
  overflow: hidden;
}

/* Header Section */
.uprn-dataset-popup__header {
  display: flex;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  background: var(--cfn-modal-header-bg);
  border-left: 4px solid var(--cfn-success);
  position: relative;
}

.uprn-dataset-popup__header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--cfn-success) 20%,
    var(--cfn-success) 80%,
    transparent
  );
  opacity: 0.5;
}

.uprn-dataset-popup__header-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--cfn-success);
  color: #ffffff;
  font-size: 0.875rem;
  box-shadow: var(--cfn-shadow-md);
}

.uprn-dataset-popup__header-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.uprn-dataset-popup__title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.uprn-dataset-popup__title {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--cfn-text-muted);
}

.uprn-dataset-popup__uprn-badge {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--cfn-success-text);
  background: var(--cfn-success-muted);
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--cfn-success);
}

/* Section Styling */
.uprn-dataset-popup__section {
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--cfn-border-muted);
  background: var(--cfn-bg-secondary);
}

.uprn-dataset-popup__section-label {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--cfn-text-muted);
  margin-bottom: 0.5rem;
}

.uprn-dataset-popup__section-label i {
  font-size: 0.625rem;
  opacity: 0.8;
}

.uprn-dataset-popup__address {
  font-size: 0.8125rem;
  color: var(--cfn-text-primary);
  line-height: 1.4;
}

/* Custom Fields (Dataset Data) */
.uprn-dataset-popup__fields {
  display: grid;
  grid-template-columns: minmax(0, 100px) minmax(0, 1fr);
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
  row-gap: 0.375rem;
  margin: 0;
  padding-left: 0.5rem;
  border-left: 2px solid var(--cfn-accent-primary-muted);
}

.uprn-dataset-popup__fields dt {
  color: var(--cfn-text-muted);
  font-size: 0.6875rem;
  font-weight: 500;
  text-transform: capitalize;
  margin: 0;
  padding-top: 0.0625rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.uprn-dataset-popup__fields dd {
  color: var(--cfn-text-primary);
  font-size: 0.8125rem;
  margin: 0;
  word-wrap: break-word;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
}

/* Footer with Coordinates */
.uprn-dataset-popup__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  background: var(--cfn-modal-footer-bg);
  border-top: 1px solid var(--cfn-border-muted);
}

.uprn-dataset-popup__coord {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
}

.uprn-dataset-popup__coord-label {
  font-size: 0.5625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--cfn-text-muted);
}

.uprn-dataset-popup__coord-value {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 0.6875rem;
  color: var(--cfn-text-secondary);
}

.uprn-dataset-popup__coord-divider {
  width: 1px;
  height: 24px;
  background: var(--cfn-border);
}

/* Scrollable fields section for many custom fields */
.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields) {
  max-height: 180px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);
}

.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar {
  width: 6px;
}

.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar-track {
  background: var(--cfn-scrollbar-track);
}

.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar-thumb {
  background: var(--cfn-scrollbar-thumb);
  border-radius: 3px;
}

.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar-thumb:hover {
  background: var(--cfn-scrollbar-thumb-hover);
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .uprn-dataset-popup__header {
    padding: 0.625rem 0.875rem;
  }

  .uprn-dataset-popup__section {
    padding: 0.625rem 0.875rem;
  }

  .uprn-dataset-popup__footer {
    padding: 0.375rem 0.875rem;
  }

  .uprn-dataset-popup__fields {
    grid-template-columns: minmax(0, 80px) minmax(0, 1fr);
  }
}

`, "",{"version":3,"sources":["webpack://./src/features/home/styles/uprn-dataset-popup.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;0CAC0C;AAC1C;EACE,yGAAyG;EACzG,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,2DAA2D;EAC3D,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,oCAAoC;EACpC,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sDAAsD;EACtD,wBAAmB;OAAnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;EACT,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,2DAA2D;EAC3D,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qDAAqD;EACvD;AACF","sourcesContent":["/* UPRN Dataset Popup - Theme-Aware Design\n * Uses cfn-theme.css CSS custom properties for consistent theming\n */\n\n/* Content styling only - outer wrapper (border-radius, shadow, width)\n   is handled by the tabbed popup system */\n.uprn-dataset-popup {\n  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--cfn-text-primary);\n  background: var(--cfn-popup-bg);\n  overflow: hidden;\n}\n\n/* Header Section */\n.uprn-dataset-popup__header {\n  display: flex;\n  gap: 0.625rem;\n  padding: 0.75rem 1rem;\n  background: var(--cfn-modal-header-bg);\n  border-left: 4px solid var(--cfn-success);\n  position: relative;\n}\n\n.uprn-dataset-popup__header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    var(--cfn-success) 20%,\n    var(--cfn-success) 80%,\n    transparent\n  );\n  opacity: 0.5;\n}\n\n.uprn-dataset-popup__header-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: var(--cfn-success);\n  color: #ffffff;\n  font-size: 0.875rem;\n  box-shadow: var(--cfn-shadow-md);\n}\n\n.uprn-dataset-popup__header-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.uprn-dataset-popup__title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.uprn-dataset-popup__title {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--cfn-text-muted);\n}\n\n.uprn-dataset-popup__uprn-badge {\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--cfn-success-text);\n  background: var(--cfn-success-muted);\n  padding: 0.125rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid var(--cfn-success);\n}\n\n/* Section Styling */\n.uprn-dataset-popup__section {\n  padding: 0.75rem 1rem;\n  border-top: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-bg-secondary);\n}\n\n.uprn-dataset-popup__section-label {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--cfn-text-muted);\n  margin-bottom: 0.5rem;\n}\n\n.uprn-dataset-popup__section-label i {\n  font-size: 0.625rem;\n  opacity: 0.8;\n}\n\n.uprn-dataset-popup__address {\n  font-size: 0.8125rem;\n  color: var(--cfn-text-primary);\n  line-height: 1.4;\n}\n\n/* Custom Fields (Dataset Data) */\n.uprn-dataset-popup__fields {\n  display: grid;\n  grid-template-columns: minmax(0, 100px) minmax(0, 1fr);\n  column-gap: 0.75rem;\n  row-gap: 0.375rem;\n  margin: 0;\n  padding-left: 0.5rem;\n  border-left: 2px solid var(--cfn-accent-primary-muted);\n}\n\n.uprn-dataset-popup__fields dt {\n  color: var(--cfn-text-muted);\n  font-size: 0.6875rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  margin: 0;\n  padding-top: 0.0625rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.uprn-dataset-popup__fields dd {\n  color: var(--cfn-text-primary);\n  font-size: 0.8125rem;\n  margin: 0;\n  word-wrap: break-word;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n}\n\n/* Footer with Coordinates */\n.uprn-dataset-popup__footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 0.5rem 1rem;\n  background: var(--cfn-modal-footer-bg);\n  border-top: 1px solid var(--cfn-border-muted);\n}\n\n.uprn-dataset-popup__coord {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.125rem;\n}\n\n.uprn-dataset-popup__coord-label {\n  font-size: 0.5625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--cfn-text-muted);\n}\n\n.uprn-dataset-popup__coord-value {\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-size: 0.6875rem;\n  color: var(--cfn-text-secondary);\n}\n\n.uprn-dataset-popup__coord-divider {\n  width: 1px;\n  height: 24px;\n  background: var(--cfn-border);\n}\n\n/* Scrollable fields section for many custom fields */\n.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields) {\n  max-height: 180px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--cfn-scrollbar-thumb) var(--cfn-scrollbar-track);\n}\n\n.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar {\n  width: 6px;\n}\n\n.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar-track {\n  background: var(--cfn-scrollbar-track);\n}\n\n.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar-thumb {\n  background: var(--cfn-scrollbar-thumb);\n  border-radius: 3px;\n}\n\n.uprn-dataset-popup__section:has(.uprn-dataset-popup__fields)::-webkit-scrollbar-thumb:hover {\n  background: var(--cfn-scrollbar-thumb-hover);\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .uprn-dataset-popup__header {\n    padding: 0.625rem 0.875rem;\n  }\n\n  .uprn-dataset-popup__section {\n    padding: 0.625rem 0.875rem;\n  }\n\n  .uprn-dataset-popup__footer {\n    padding: 0.375rem 0.875rem;\n  }\n\n  .uprn-dataset-popup__fields {\n    grid-template-columns: minmax(0, 80px) minmax(0, 1fr);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
